<template>
  <div class="tabBox">
    <el-table :data="tableData" style="width: 100%;text-align: center;" highlight-current-row @current-change='currentChange' @row-click="check_risk">
      <el-table-column prop="title" align="center" label="名称">
      </el-table-column>
      <el-table-column prop="referenceCode" align="center" label="文号">
      </el-table-column>
            <el-table-column prop="category" align="center" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.category == 1">法律法规规章制度</span>
                <span v-if="scope.row.category == 2">重污染天气</span>
                <span v-if="scope.row.category == 3">突发环境事件</span>
                <span v-if="scope.row.category == 4">其他</span>
              </template>
      </el-table-column>
      <el-table-column prop="orgName" align="center" label="上传机构">
      </el-table-column>
      <el-table-column align="center" label="发文日期">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.releaseDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="文件">
        <template slot-scope="scope">
          <a style="color:#1f2d3d;text-decoration: underline;" @click='download(scope.row.id)'>{{scope.row.fileName}}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import burst from '@/data/basic/manage/guidefile'
import moment from 'moment'
export default {
  props: ['arrList'],
  data() {
    return {
      tableData: [],

    }
  },
  watch: {
    arrList() {
      this.tableData = this.arrList
    }
  },
  created() {
    // this.get_heavy_list()
  },
  methods: {
    // 格式化时间
    formatTime(time) {
      if (time) {
        return moment(time).format('YYYY/MM/DD')
      }
    },
    // 排序

    download(id) {
      if (!id) {
        this.$message({
          message: '文件获取失败,请稍候重试',
          type: 'warning'
        });
        return
      }
      window.location.href = `/api/emer/file/guidance/download?id=${id}`
    },
    currentChange(row) {
      let currId = row ? row.id : null
      this.$emit('currentChange', currId)
    },
    // 点击行
    check_risk(row) {
      if (row) {
        sessionStorage.modifyGguidefile = JSON.stringify(row)
      }
    }
  }
}

</script>
<style>


</style>



// WEBPACK FOOTER //
// heavypoll.vue?50aed822